'use client'

import * as React from 'react'

import { cn } from '@lib/cn'

const stickyClass = 'sticky top-0 z-20 backdrop-blur-xl bg-muted py-1 rounded-t-lg'

function Table({
  className,
  containerClassName,
  ...tableProps
}: React.ComponentProps<'table'> & { containerClassName?: string }) {
  return (
    <div data-slot='table-container' className={cn('relative w-full', containerClassName)}>
      <table
        data-slot='table'
        className={cn('w-full min-w-full caption-bottom text-sm border-collapse bg-card', className)}
        {...(tableProps as React.ComponentProps<'table'>)}
      />
    </div>
  )
}

function TableHeader({ className, ...props }: React.ComponentProps<'thead'>) {
  return <thead data-slot='table-header' className={cn('!border-0', stickyClass, className)} {...props} />
}

function TableBody({ className, ...props }: React.ComponentProps<'tbody'>) {
  return <tbody data-slot='table-body' className={cn(className)} {...props} />
}

function TableFooter({ className, ...props }: React.ComponentProps<'tfoot'>) {
  return <tfoot data-slot='table-footer' className={cn('font-medium rounded-b-lg', className)} {...props} />
}

function TableRow({ className, ...props }: React.ComponentProps<'tr'>) {
  return (
    <tr
      data-slot='table-row'
      className={cn(
        'h-10 bg-transparent hover:bg-muted/50 data-[state=selected]:bg-muted transition-colors',
        className,
      )}
      {...props}
    />
  )
}

function TableHead({ className, ...props }: React.ComponentProps<'th'>) {
  return (
    <th
      data-slot='table-head'
      className={cn(
        'border-0',
        'text-foreground min-h-10 px-2 text-left align-middle font-medium whitespace-nowrap [&:has([role=checkbox])]:pr-0 [&>[role=checkbox]]:translate-y-[2px]',
        className,
      )}
      {...props}
    />
  )
}
function TableHeadRow({ className, ...props }: React.ComponentProps<'tr'>) {
  return <tr data-slot='table-head-row' className={cn(stickyClass, className)} {...props} />
}

function TableCell({ className, ...props }: React.ComponentProps<'td'>) {
  return (
    <td
      data-slot='table-cell'
      className={cn(
        'p-2 align-middle whitespace-nowrap [&:has([role=checkbox])]:pr-0 [&>[role=checkbox]]:translate-y-[2px]',
        className,
      )}
      {...props}
    />
  )
}

/*function _TableCaption({ className, ...props }: React.ComponentProps<'caption'>) {
  return (
    <caption data-slot='table-caption' className={cn('text-muted-foreground mt-4 text-sm', className)} {...props} />
  )
}*/

export { Table, TableHeader, TableHeadRow, TableBody, TableFooter, TableHead, TableRow, TableCell }
